module.exports = __webpack_public_path__ + "static/media/image_Ellipse1_ICON.eabe65c5.svg";